'use es6';

import Raven from 'raven-js';
import PortalIdParser from 'PortalIdParser';
import * as RequestClients from '../../api/requestClients';
import { onFetchContentSchemaSuccess, onFetchContentSchemaFailed } from 'ContentEditorUI/redux/actions/appActions';
import { getContentTypeName } from 'ContentEditorUI/redux/selectors/contentTypeSelector';
import { standardFetchCustomModules, fetchModuleSchemasFailed, fetchModuleSchemasSucceeded } from 'ContentEditorUI/redux/actions/moduleSchemaActions';
import { getContentAssistantSettings, getBrandVoiceSettings } from 'ContentEditorUI/redux/actions/contentAssistantActions';
import { DEFAULT_ACCOUNT_BUSINESS_UNIT_ID } from 'ui-business-units-lib/constants/BusinessUnit';
function isLandingPageWithEditorV2(response) {
  const content = response && response.content;
  if (!content) return false;
  return content.subcategory === 'landing_page' && content.editorVersion === '2.0';
}
function redirectToEditorV2(contentId) {
  const portalId = PortalIdParser.get();
  window.location.replace(`/content-v2/${portalId}/editor/pages/${contentId}/edit`);
}
export const fetchContentSchema = () => dispatch => {
  const contentSchemaRequest = RequestClients.fetchContentSchema();
  return contentSchemaRequest.then(result => dispatch(onFetchContentSchemaSuccess({
    result
  })), result => dispatch(onFetchContentSchemaFailed({
    result
  })));
};
export const combinedInitialRequestThunk = () => (dispatch, getState) => {
  const contentPromise = dispatch(fetchContentSchema());
  const globalPromise = RequestClients.fetchGlobalModules().then(response => ({
    response
  }), error => ({
    error
  }));
  const customModulePromise = dispatch(standardFetchCustomModules({
    shouldUseElasticSearch: true
  }));
  return Promise.all([globalPromise, customModulePromise, contentPromise]).then(requests => {
    var _contentSchema$respon, _contentSchema$respon2, _ref;
    const [globalModules = {}, customModules = {}, contentSchema = {}] = requests;
    const categoryName = getContentTypeName(getState());
    if (isLandingPageWithEditorV2(contentSchema === null || contentSchema === void 0 ? void 0 : contentSchema.response)) {
      redirectToEditorV2(contentSchema.response.content.id);
      return Promise.resolve();
    }

    // Need to check for errors again, because we already dispatch the failure action for each
    // of the sub-requests, which turns it into a resolved promise again
    for (const request of requests) {
      if (!request) {
        Raven.captureMessage('request is not defined ', {
          extra: {
            requests
          }
        });
      }
      if (request && request.error) {
        return dispatch(fetchModuleSchemasFailed(request));
      }
    }
    const activeDomainBuId = contentSchema === null || contentSchema === void 0 || (_contentSchema$respon = contentSchema.response) === null || _contentSchema$respon === void 0 || (_contentSchema$respon = _contentSchema$respon.context) === null || _contentSchema$respon === void 0 || (_contentSchema$respon = _contentSchema$respon.active_domain) === null || _contentSchema$respon === void 0 ? void 0 : _contentSchema$respon.buId;
    const contentBuId = contentSchema === null || contentSchema === void 0 || (_contentSchema$respon2 = contentSchema.response) === null || _contentSchema$respon2 === void 0 || (_contentSchema$respon2 = _contentSchema$respon2.content) === null || _contentSchema$respon2 === void 0 ? void 0 : _contentSchema$respon2.businessUnitId;
    dispatch(getBrandVoiceSettings({
      businessUnitId: (_ref = activeDomainBuId !== null && activeDomainBuId !== void 0 ? activeDomainBuId : contentBuId) !== null && _ref !== void 0 ? _ref : DEFAULT_ACCOUNT_BUSINESS_UNIT_ID
    }));
    return dispatch(fetchModuleSchemasSucceeded({
      categoryName,
      globalModules: globalModules.response,
      customModules: customModules.response
    }, {
      fromSuperStoreCache: customModules.fromSuperStoreCache
    }));
  });
};

/**
 * Skip brand voice fetch during initial requests
 * We will fetch it after content schema is available
 */
const skipBrandVoiceFetchConfig = {
  brandVoice: {
    skip: true
  }
};
export const contentAssistantThunk = () => dispatch => dispatch(getContentAssistantSettings(skipBrandVoiceFetchConfig));